<template>
  <div>
    <AppBar></AppBar>

    <div class="page-content header-clear-small">
      <div class="row text-center mb-0">
        <router-link to="/round" class="col-6 pr-0">
          <div class="card card-style mr-2 mb-3">
            <img class="img-fluid" style="padding: 10px;" src="/images/home/round.png">
            <h1 class="pt-4">Rounds</h1>
          </div>
        </router-link>
        <router-link to="/stand" class="col-6 pl-0">
          <router-link to="/stand" class="card card-style ml-2 mb-3">
            <img class="img-fluid" style="padding: 10px;" src="/images/home/stand.png">
            <h1 class="pt-4">Stands</h1>
          </router-link>
        </router-link>

        <router-link to="/farming" class="col-6 pr-0">
          <div class="card card-style mr-2">
            <img class="img-fluid" style="padding: 10px;" src="/images/home/farming.png">
            <h1 class="pt-4">Farming</h1>
          </div>
        </router-link>
        <router-link class="col-6 pl-0" to="/investment" data-menu="menu-listed-menus">
          <div class="card card-style ml-2">
            <img class="img-fluid" style="padding: 10px;" src="/images/home/investments.png">
            <h1 class="pt-4">Investments</h1>
          </div>
        </router-link>

      <router-link to="/book" class="col-6 pr-0">
        <div class="card card-style ml-2">
          <img class="img-fluid" style="padding: 10px;" src="/images/home/books.png">
          <h1 class="pt-4">Books</h1>
        </div>
      </router-link>

      <router-link to="/course" class="col-6 pl-0">
        <div class="card card-style ml-2">
          <img class="img-fluid" style="padding: 10px;" src="/images/home/coaching.png">
          <h1 class="pt-4">Coaching </h1>
        </div>
      </router-link>
      <router-link to="/update" class="col-6 pr-0">
        <div class="card card-style ml-2">
          <img class="img-fluid" style="padding: 10px;" src="/images/home/news.png">
          <h1 class="pt-4">News & Updates</h1>
        </div>
      </router-link>
      <router-link to="/prayers" class="col-6 pl-0">
        <div class="card card-style ml-2">
          <img class="img-fluid" style="padding: 10px;" src="/images/home/prayer.png">
          <h1 class="pt-4">Prayer Requests</h1>
        </div>
      </router-link>

      </div>
      <router-link to ="/query">
                <div class="card card-style mb-3">
                    <div class="d-flex">
                        <div class="pl-3 ml-2 align-self-center">
                            <h1 class="pt-4">General Queries</h1>
                            <p class="font-11 opacity-50 mt-n2 mb-4">For all queries needing admin assistance </p>
                        </div>
                        <div class="ml-auto mr-4 align-self-center card" style="height: 200px;">
                          <img class="img-fluid" src="/images/home/query.png">
                        </div>
                    </div>
                </div>
      </router-link>
      <div>
    </div>
    </div>

    <FooterBar></FooterBar>
  </div>
</template>

<script>
import AppBar from "../components/AppBar";
import FooterBar from "../components/FooterBar";
export default {

  name: "Home",
  mounted() {

  },

  
  components: {
    AppBar,
    FooterBar
  },

};
</script>

<style scoped>
.round{
  background-image: url("/images/home/round.png");
}
.page-content {
  /*margin-top: 50px;*/
}
</style>
